// Generated with util/create-component.js
import Table from './Base';

export default Table;
